export enum ClickTypeEnum {
  SINGLE = 0,
  DOUBLE = 1,
}
